module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-01.2a8190eeb54b0e049f15de7849dbf11c.png";